const en = {
	risk: {
		riskTitle: 'Risk Transcation Management',
		tips1: 'You have ',
		tips2: ' orders that are at risk. Please contact the cardholder for confirmation within 7 days of the transaction being initiated.If it expires, the transaction will be automatically cancelled.pingpong will assist you to complete',
		tipsNoPermission: ' risk orders. PingPong will review the risk and make a decision. If you have any questions, please contact us. Thank you for your understanding.',
		emptyText: 'You have no risk orders'
	},
	table: {
		tradingTime: 'Transaction Time',
	    storeName: 'Website',
		omniStoreName: 'Store/Website',

		groupName: 'Group',
		outFlowId: 'Purchase Transaction ID',
		currency: 'Currency',
		payBrand: 'Payment Method',
		amount: 'Amount',
		type: 'Transaction Type',
		status: 'Status',
		action: 'Action',
		detail: 'Detail'
	}
}

export default en
